import { trackCustomPage, trackAction } from '../tracker';

import {
  PROP_CONTEXT_DIMENSION1,
  PROP_CONTEXT_DIMENSION3,
  PROP_FORM_LIST,
  PROP_TRACK_ACTION,
} from '../constants';

const companyPageCreationTracking: any = {
  step0: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_basic_info',
      [PROP_FORM_LIST]: 'entity_page_company_profile_creation_form_open',
    },
    nextAction: 'recruiting_company_page_creation_contact_2',
  },
  step1: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_contact_detail',
    },
    nextAction: 'recruiting_company_page_creation_logo_3',
  },
  step2: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_logo',
    },
    nextAction: 'recruiting_company_page_creation_description_4',
  },
  step3: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_description',
    },
    nextAction: 'recruiting_company_page_create_5',
  },
  step4: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_confirmation',
      EventCompaniesProfileCreate: 1,
      [PROP_CONTEXT_DIMENSION1]: 'entity_page_basic',
      [PROP_CONTEXT_DIMENSION3]: 'entity_page_editor',
      [PROP_FORM_LIST]: 'entity_page_company_profile_creation_form_sent',
    },
    nextAction: 'recruiting_company_page_create_5',
  },
};

export const trackCompanyPageCreationStep = (currentStep: 0 | 1 | 2 | 3) => {
  const stepView = companyPageCreationTracking?.[
    `step${currentStep}`
  ]?.stepView;

  const { pageName, ...context} = stepView;
  pageName && trackCustomPage(pageName, {}, context);
};

export const trackCompanyPageCreationNextAction = (currentStep: 0 | 1 | 2 | 3) => {
  const nextAction = companyPageCreationTracking?.[`step${currentStep}`].nextAction;

  nextAction && trackAction({ [PROP_TRACK_ACTION]: nextAction });
};
